import type { IconNamesType } from 'ksnm-common-ui/lib/Icon/types';

import type { ResourceNameRoutesKeys } from '@stores/userStore';

import type { Route } from '../../../AppRouter/types';

export interface DesignMenuRouteInterface extends Route {
  iconName?: IconName;
  key: string;
  title?: string;
  includedRoutes?: (string | undefined)[];
}

export interface DownMenuInterface extends Route {
  key: string;
  title?: string;
  path?: string;
  iconName: IconNamesType;
  includedRoutes?: (string | undefined)[];
  hidden?: boolean;
  onClick?: () => void;
  resourceName?: ResourceNameRoutesKeys | ResourceNameRoutesKeys[];
}

export enum IconName {
  HOME = 'viewModule',
  PUBLICATION = 'listAlt',
  DICTIONARY = 'dictionary',
  ETL_PROCESS = 'calculate',
  REPORTING_TREE = 'accountTree',
  LOGS = 'squareEye',
  DATA_CONTROL = 'dataControlMenu',
  SECURITY = 'security',
}
